import { useTranslation } from 'react-i18next';

interface CategorySelectorProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}

export default function CategorySelector({
  selectedCategory,
  setSelectedCategory,
}: CategorySelectorProps) {
  const { t } = useTranslation(); // useTranslation 훅 사용

  const categories = [
    'MODELING',  // 번역 키로 사용할 값
    'BUILDING',
    'ENTITY',
    'PIXEL',
    'FREE',
    'SCRIPT',
    'SKIN',
    'SKILL',
    'PLUGIN',
  ];

  return (
    <section className="flex space-x-4 justify-center mt-[48px] mobile:flex-wrap mobile:gap-2 mobile:space-x-0 mobile:px-3 mobile:mt-8">
      {categories.map((category, index) => (
        <div key={index} className="category-group">
          <div
            onClick={() => setSelectedCategory(category)}
            className={`
              min-w-[120px] mobile:min-w-0 
              h-[46px] mobile:h-[28px] 
              flex items-center justify-center px-5
              rounded-lg
              transition-all duration-200 ease-out
              cursor-pointer
              relative
              ${
                selectedCategory === category 
                ? 'bg-slate-900 text-white' 
                : 'bg-slate-50 hover:bg-slate-100'
              }
              ${
                selectedCategory === category 
                ? 'after:content-[""] after:absolute after:bottom-[-8px] after:left-1/2 after:transform after:-translate-x-1/2 after:w-1 after:h-1 after:bg-slate-900 after:rounded-full'
                : ''
              }
            `}
          >
            <span className={`
              Pretendard-Medium
              text-[15px] mobile:text-[11px]
              ${selectedCategory === category ? 'text-white' : 'text-slate-600'}
            `}>
              {t(`categories.${category}`)}
            </span>
          </div>
        </div>
      ))}
    </section>
  );
}
